import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { FirstParameter } from 'vtils/types'

export class PageUtils {
  static defineShareParams(
    params: () => Partial<FirstParameter<typeof dcb['share']>>,
  ) {
    return computed(params)
  }

  static scrollTo(el: any) {
    document.querySelector('.__page_container__')!.scrollTo({
      top:
        el.offsetTop -
        (document.querySelector('.__page_header__')?.getBoundingClientRect()
          .height || 0),
      behavior: 'smooth',
    })
  }
}
